import './index.less'
import { getMembershipPriceProductInfo, createMembershipPriceCoupon, } from "@utils/api.js"
import { Decimal } from 'decimal.js'
import { cookie, copyString, } from "@utils/index.js"

class ProductMembershipPrice {
  constructor() {
    // 获取 会员价 DOM
    this.DOM = document.querySelector('#app-membership-price')
    this.variantWrap = document.querySelector(".variant-input-wrap")

    if(!this.DOM) return

    const {
      displayText, spuId, spuTitle, variantId, variantTitle,
      offText, rulesText, copyText, copiedText, claimText,
      getText, codeText, loginToApplyText, copyToApplyText, clickToApplyText,
      claimCodeSuccessTipText, copyCodeSuccessTipText,

      actId, endsInText, noLoginTitle, noLoginBtnText, 
      loggedAndClaimedWithAutoApplyTitle, loggedAndClaimedWithAutoApplyBtnText,
      loggedAndClaimedWithNoAutoApplyTitle, loggedAndClaimedWithNoAutoApplyBtnText,
      loggedAndUnclaimedTitle, loggedAndUnclaimedBtnText,
    } = this.DOM.dataset

    this.variants = [] // 初始化，所有变体信息为空
    this.spuInfo = [] // 初始化，spu信息为空
    this.curSkuInfo = {}  // 初始化，sku信息为空
    this.displayText = displayText === 'true' // 是否是纯文案显示
    this.spuTitle = spuTitle // SPU title
    this.variantId = variantId // 变体 ID
    this.skuTitle = variantTitle // 变体 title
    this.discountAmount = 0 // 优惠金额

    this.actId = actId // 活动 ID
    this.timer = null
    window.productMemberPriceInfo = [] // 存储会员价信息

    this.i18nText = {
      offText,
      rulesText,
      copyText,
      copiedText,
      claimText,
      getText,
      codeText,
      loginToApplyText,
      copyToApplyText,
      clickToApplyText,
      claimCodeSuccessTipText,
      copyCodeSuccessTipText,

      endsInText,
      noLoginTitle,
      noLoginBtnText,
      loggedAndClaimedWithAutoApplyTitle,
      loggedAndClaimedWithAutoApplyBtnText,
      loggedAndClaimedWithNoAutoApplyTitle,
      loggedAndClaimedWithNoAutoApplyBtnText,
      loggedAndUnclaimedTitle,
      loggedAndUnclaimedBtnText,
    }

    // 获取所有变体信息
    if(document.querySelector('#membership-price-variant[type="application/json"]')) {
      const variantInfo = JSON.parse(document.querySelector('#membership-price-variant[type="application/json"]').textContent)
      this.variants = [].concat(variantInfo)
    } else if(document.querySelector('#membership-price-variants[type="application/json"]')) {
      this.variants = JSON.parse(document.querySelector('#membership-price-variants[type="application/json"]').textContent)
    }

    this.init(spuId)

    // 旧 main-product 触发variant变化 - 改变当前变体
    if(this.variantWrap) { // 就main-product
      this.variantWrap.querySelectorAll('label').forEach(item => {
        item.onclick = (e) => {
          this.variantId = e.target.dataset.productLabel
          this.curSkuInfo = this.spuInfo.find(it => it.skuId.toString() === this.variantId.toString())

          // 更新 skuTitle
          this.skuTitle = e.target.querySelector('.goods-title').innerText

          // 清空倒计时
          this.timer && clearTimeout(this.timer)

          this.initDOM()
        }
      })
    }

    // 新 main-product 触发variant变化 - 改变当前变体
    if (document.querySelector('variant-fields')) {
      document.addEventListener('variantChangeEvent', e => {
        const currentVariant = e.detail.variant
        if (currentVariant) {
          this.variantId = currentVariant.id
          this.curSkuInfo = this.spuInfo.find(it => it.skuId.toString() === this.variantId.toString())

          // 更新 skuTitle
          this.skuTitle = currentVariant.title

          // 清空倒计时
          this.timer && clearTimeout(this.timer)

          setTimeout(() => {
            this.initDOM()
          }, 200)
        }
      })
    }
  }
  async init(spuId) {
    let that = this
    loadCSS(pageInfo.__webpack_public_path__ + 'plugin-app-membership-price.min.css', () => {
      document.querySelector(".product-membership-price-wrap") && document.querySelector(".product-membership-price-wrap").classList.remove("hidden");
    });

    try {
      const data = await getMembershipPriceProductInfo({
        shopifyShopId: window.pageInfo.shopId,
        spuId: spuId,
        actId: this.actId ? parseInt(this.actId.match(/\d+/)[0], 10) : null, // 活动 ID
      })

      if (data?.data) {
        this.spuInfo = data.data
        this.curSkuInfo = this.spuInfo.find(it => it.skuId.toString() === this.variantId.toString())

        // 登录成功后返回，自动获取 code 码
        if(this.curSkuInfo && window.pageInfo.customerInfo.id && sessionStorage.getItem('jk_sku_member_code')) {
          let _params = new URLSearchParams(window.location.search);
          const pendding = _params.get("pendding_member_code")
          if(pendding) {
            if (this.curSkuInfo.discountCode) {
              this.successCallback()
            } else {
              // 登录后自动复制，被浏览器禁止
              await this.updateSpuInfo(false)
            }

            // 更新 url
            _params.delete("pendding_member_code")
            const newUrl = window.location.origin + window.location.pathname + "?" + _params.toString();
            window.history.pushState({ path: newUrl }, "", newUrl);

            sessionStorage.removeItem('jk_sku_member_code')
          } else {
            sessionStorage.removeItem('jk_sku_member_code')
            this.initDOM()
          }
        } else {
          this.initDOM()
        }
      }
    } catch (err) {
      pushMessage(err.message, "warning");
      this.initDOM()
    }
  }
  // 获取选中的变体
  getSelectedVariant() {
    return this.variants.find(item => item.id.toString() === this.variantId.toString())
  }
  // 更新 #spuInfo
  async updateSpuInfo(needCopy, target) {
    try {
      const coupon = await createMembershipPriceCoupon({
        shopifyShopId: window.pageInfo.shopId,
        settingId: this.curSkuInfo.benefitId,
        activeId: this.curSkuInfo.activeId,
        skuId: this.curSkuInfo.skuId,
      })
  
      if (coupon.data) {
        this.curSkuInfo = coupon.data
        // 更新 #spuInfo
        this.spuInfo = this.spuInfo.map(item => {
          if (item.skuId === coupon.data.skuId) {
            return coupon.data
          }
          return item
        })
  
        // 是否需要复制
        if (needCopy) {
          copyString(this.curSkuInfo.discountCode, () => this.successCallback())
        } else {
          this.successCallback()
        }
      }
    } catch (err) {
      pushMessage(err.message, "warning");
    } finally {
      target?.classList?.remove?.('btn--loading')
    }
  }
  successCallback() {
    // 提示 copy 成功
    pushSuccessMessage(this.i18nText.claimCodeSuccessTipText)
  
    // 设置 cookie
    let d = new Date()
    d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)) // 7天
    document.cookie = `discount_code=${this.curSkuInfo.discountCode};expires=${d.toGMTString()};path=/`

    this.initDOM()
  }
  async initDOM() {
    // 3600 plus 会员价 【已登录】
    if (this.actId && window.pageInfo?.customerInfo?.id) {
      // 初始化全局 productMemberPriceInfo 变量
      window.productMemberPriceInfo = window.productMemberPriceInfo || []

      this.spuInfo.forEach(item => {
        this.variants.forEach(variant => {
          if (item.skuId.toString() === variant.id.toString()) {
            const variantFields = document.querySelector('variant-fields')
            const parentEl = variantFields?.querySelector(`input[data-id="${variant.id}"]`)?.parentElement

            // 更新 选中变体的价格显示
            if (variant.membership_price < variant.price && variantFields) {
              const memberIds = window.productMemberPriceInfo.map(it => it.id.toString())
              if (!memberIds.includes(variant.id.toString()) && item.discountCode) {
                window.productMemberPriceInfo.push({
                  id: variant.id,
                  membership_price: variant.membership_price || variant.price, // 会员价
                  price: variant.price,
                  compare_at_price: variant.compare_at_price,
                })

                // 更新变体价格显示
                if (parentEl?.querySelector('.option-price span')) {
                  parentEl.querySelector('.option-price span').innerText = formatMoney(variant.membership_price || variant.price)
                }

                // 更新划线价
                if (
                  !parentEl?.querySelector('.option-price span.origin-price') &&
                  parentEl?.querySelector('.option-price') &&
                  variant.compare_at_price > variant.membership_price
                ) {
                  parentEl.querySelector('.option-price').insertAdjacentHTML(
                    'beforeend',
                    `<span class="origin-price text-sm text-[#999] font-medium line-through">
                      ${formatMoney(variant.compare_at_price)}
                    </span>`
                  )
                }
              }
            }
          }
        })
      })
    }

    if (!this.curSkuInfo || Object.keys(this.curSkuInfo)?.length === 0) {
      this.DOM.innerHTML = ''
      this.DOM.parentElement.style.display = 'none'
      this.DOM.parentElement.setAttribute('data-show', false)
      return
    }

    const {
      discountCode,  // 折扣码
      valueType,     // 折扣类型，0: 固定金额, 1: 百分比
      value,         // 折扣值
      imageType,     // 图片类型，0: 固定图片，1: 底图（数值作取值）
      imageUrl,      // 图片url
      ruleInfo,      // 规则信息
      showCountDown, // 是否显示倒计时
      countDownLimitDays, // 倒计时天数限制
      start: startDate,     // 活动开始时间
      end: endDate,       // 活动结束时间
    } = this.curSkuInfo

    // 3600 plus 会员价
    if (this.actId) {
      const serverTime = await this.getServerTime()
      // 如果服务端时间，大于 结束时间，则直接 return
      if (serverTime < new Date(startDate).getTime() || serverTime >= new Date(endDate).getTime()) {
        // 清空DOM
        this.DOM.innerHTML = ''
        this.DOM.parentElement.setAttribute('data-show', false)
        return
      }

      // 提取时间计算逻辑为独立函数
      const calculateStartTime = (startDate, endDate, countDownLimitDays = 0) => {
        if (countDownLimitDays == 0) {
          return new Date(startDate).getTime();
        }

        const limitTime = countDownLimitDays * 86400000; // 24*60*60*1000
        const limitStartTime = new Date(endDate).getTime() - limitTime;

        return Math.max(limitStartTime, new Date(startDate).getTime());
      }

      if (showCountDown === 1 && endDate) {
        /**
         * 1、显示倒计时
         * 2、新增逻辑, 到期多少天显示 逻辑
         * 3、倒计时开始：
         *      1、当countDownLimitDays为null时 取startDate
         *      1、当startDate大于endDate - countDownLimitDays 取startDate
         *      2、当startDate小于endDate - countDownLimitDays 取 endDate - countDownLimitDays
         */
        const startTime = calculateStartTime(startDate, endDate, countDownLimitDays);

        // 显示会员价 DOM
        this.showMembershipPriceDOM({
          discountCode,
          imageType,
          imageUrl,
          ruleInfo,
          isShowCountDown: startTime <= serverTime ? true : false,
          serverTime,
          startTime: new Date(startDate).getTime(),
          endTime: new Date(endDate).getTime(),
        })
      } else {
        // 显示会员价 DOM
        this.showMembershipPriceDOM({ discountCode, imageType, imageUrl, ruleInfo, isShowCountDown: false, })
      }
    } else {
      // 计算优惠额
      this.discountAmount = this.calcDiscountPrice({value, valueType, })
  
      // 显示会员价 DOM
      this.showMembershipPriceDOM({ discountCode, imageType, imageUrl })
    }
  }
  async getServerTime() {
    return new Promise(async (resolve, reject) => {
      const { api, cr, shopId, } = window.pageInfo
      // 获取服务器时间
      const url = `${api}/osconsumerapi/v1/com/get-server-time?shopify_shop_id=${shopId || ''}&cr=${cr || ''}`
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        headers: { "Content-Type": "application/json", },
      });
      const { data: { datetime }, } = await response.json();
      const serverTime = new Date(datetime).getTime()
      resolve(serverTime)
    })
  }
  // 渲染 会员价 DOM
  showMembershipPriceDOM(payload) {
    this.renderMembershipPriceDOM(payload)
    this.DOM.parentElement.style.display = 'block'
    this.DOM.parentElement.setAttribute('data-show', true)
  }
  renderMembershipPriceDOM(payload) {
    const { discountCode, imageType, imageUrl, ruleInfo, isShowCountDown, serverTime, startTime, endTime, } = payload
    // 最新的 code 码
    const cookieCode = cookie.get('discount_code')

    // 3600 plus 会员价
    if (this.actId) {
      const variantInfo = this.getSelectedVariant()
      this.DOM.innerHTML = this.render3600PlusImgDOM({ cookieCode, discountCode, variantInfo, ruleInfo, isShowCountDown })

      // 初始化倒计时数据
      this.countdownDOM = this.DOM.querySelector('[data-count-down]');
      this.countdownDOM && this.initCountdownData({ serverTime, startTime, endTime });

      // 【已登录】 + 【已领取】 + 【有会员价】
      if (window.pageInfo?.customerInfo?.id && discountCode && variantInfo.membership_price) {
        // 更新 【选中变体的价格】、添加【选中变体的划线价】
        if (variantInfo.membership_price < variantInfo.price && document.querySelector('variant-fields')) {
          const parentEl = document.querySelector(`variant-fields input[data-id="${variantInfo.id}"]`)?.parentElement
          if (parentEl?.querySelector('.option-price span.price')) { 
            parentEl.querySelector('.option-price span.price').innerText = formatMoney(variantInfo.membership_price)
          }

          // 添加 划线价
          if (
            !parentEl?.querySelector('.option-price span.origin-price') &&
            parentEl?.querySelector('.option-price') &&
            variantInfo.compare_at_price > variantInfo.membership_price
          ) {
            parentEl.querySelector('.option-price').insertAdjacentHTML(
              'beforeend',
              `<span class="origin-price text-sm text-[#999] font-medium line-through">
                ${formatMoney(variantInfo.compare_at_price)}
              </span>`
            )
          }
        }
        
        // 更新 吸底购物车【价格】、【划线价】、【折扣】
        if (variantInfo.membership_price < variantInfo.price && document.querySelector('jky-sticky-cart')) {
          const stickyCart = document.querySelector('jky-sticky-cart')?.querySelector('.sticky_cart_price_wrap')
          if (!stickyCart) return

          stickyCart.querySelector('.sticky_cart_price').innerText = formatMoney(variantInfo.membership_price)

          // 插入【划线价】
          if (!stickyCart.querySelector('.product--originPrice')) {
            stickyCart.insertAdjacentHTML(
              'beforeend',
              `<span class="product--originPrice font-normal line-through" style="display:block">
                ${formatMoney(variantInfo.compare_at_price)}
              </span>`
            )
          }
          // 更新 划线价
          else {
            stickyCart.querySelector('.product--originPrice').style.display = 'block'
          }

          // 折扣金额
          const dis_amount = Math.floor((variantInfo.compare_at_price - variantInfo.membership_price) / 100) * 100
          let money_format = window?.pageInfo?.currency?.money_format?.replace('{{amount}}', '{{amount_no_decimals}}')
          money_format = money_format?.replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
          const discountPrice = formatMoney(dis_amount, money_format)

          // 插入【折扣】
          if (!stickyCart.querySelector('.product-price--discount_amount')) {
            const format = stickyCart.dataset.discountFormat
            stickyCart.insertAdjacentHTML(
              'beforeend',
              `<span class="product-price--discount_amount" style="display:block" data-format="${format}" data-hide-origin-price>
                ${format.replace('()', discountPrice)}
              </span>`
            )
          }
          // 更新折扣
          else {
            const discountEl = stickyCart.querySelector('.product-price--discount_amount')
            discountEl.innerText = discountEl.dataset.format.replace('()', discountPrice)
            discountEl.style.display = 'inline-block'
          }
        }
      }
    } else {
      // 文本样式
      if (this.displayText) {
        this.DOM.innerHTML = this.renderTextDOM({ cookieCode, discountCode, })
      }
      // 图片样式
      else {
        this.DOM.innerHTML = this.renderImgDOM({ cookieCode, discountCode, imageType, imageUrl, })
      }
    }

    // 未登录
    if ($('[data-member-price-claim]').length > 0) {
      $('[data-member-price-claim]').off('click').on('click', (e) => {
        sessionStorage.setItem('jk_sku_member_code', this.variantId)
        let _params = new URLSearchParams(window.location.search)
        _params.set("pendding_member_code", "1")

        window?.jackeryLoginApp?.modalLogin({
          return_url: `${location.origin}${location.pathname}?${_params.toString()}`,
          register_act: this.actId ? '3600plus-Register' : 'MB-Register',
          tag: this.actId ? '3600plus-Register' : null
        })

        // 3600 plus 会员价
        if (this.actId) {
          // 数据埋码
          this.GAEvent({
            product_spu_name: this.spuTitle,
            module: 'EarlyBirdCoupons',
            position: this.DOM.querySelector('h3').innerText || '',
            button_name: e.currentTarget.innerText || '',
            content: '',
            status: window.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })
        }
        // 非 3600 plus 会员价
        else {
          // 数据埋码
          this.GAEvent({
            position: this.spuTitle + ' # ' + this.skuTitle,
            button_name: this.i18nText.claimText,
            type: this.displayText ? 'text' : 'pic',
            status: window.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })
        }
      })
    }
    

    // 已登录未领取
    if ($('[data-member-price-get]').length > 0) {
      $('[data-member-price-get]').off('click').on('click', async (e) => {
        e.currentTarget.classList.add('btn--loading')
          try {
            // 更新 #spuInfo
            await this.updateSpuInfo(true, e.currentTarget)
          } catch (err) {
            pushMessage(err.message, "warning");
          } finally {
            e.currentTarget.classList.remove('btn--loading')
          }

          // 3600 plus 会员价
          if (this.actId) {
            // 数据埋码
            this.GAEvent({
              product_spu_name: this.spuTitle,
              module: 'EarlyBirdCoupons',
              position: this.DOM.querySelector('h3').innerText || '',
              button_name: e.currentTarget.innerText || '',
              content: '',
              status: window.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
            })
          }
          // 非 3600 plus 会员价
          else {
            // 数据埋码
            this.GAEvent({
              position: this.spuTitle + ' # ' + this.skuTitle,
              button_name: this.i18nText.getText,
              type: this.displayText ? 'text' : 'pic',
              status: window.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
            })
          }
      })
    }
    

    // 注册 rules 点击事件
    if ($('[data-member-price-rules]').length > 0) {
      $('[data-member-price-rules]').off('click').on('click', (e) => {
        const popupHtml = this.renderRulesDOM()
    
        window.ZModle.getInstance(popupHtml, {
          id: `membership-price-rules-popup-${this.curSkuInfo.skuId}`,
          class: "membership-price-popup-wrap",
          cb: () => {}
        })
        
        // 3600 plus 会员价
        if (this.actId) {
          // 数据埋码
          this.GAEvent({
            product_spu_name: this.spuTitle,
            module: 'EarlyBirdCoupons',
            position: this.DOM.querySelector('h3').innerText || '',
            button_name: 'Rules',
            content: e.currentTarget.dataset.code || '',
            status: window.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })
        }
        // 非 3600 plus 会员价
        else {
          // 数据埋码
          this.GAEvent({
            position: this.spuTitle + ' # ' + this.skuTitle,
            button_name: this.i18nText.rulesText,
            type: this.displayText ? 'text' : 'pic',
            status: window.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })
        }
      })
    }

    // 注册 copy 事件
    if ($('[data-member-price-copy]').length > 0) {
      $('[data-member-price-copy]').off('click').on('click', (e) => {
        this.registerCopyEvent(e, true, cookieCode)
      })
    }
    if ($('[data-member-price-code]').length > 0) {
      $('[data-member-price-code]').off('click').on('click', (e) => {
        this.registerCopyEvent(e, false, cookieCode)
      })
    }
  }
  // 注册 copy 事件
  registerCopyEvent(e, needSetCookie, cookieCode) {
    const { code, copyText, copiedText, } = e.currentTarget.dataset
    if (code) {
      copyString(code, () => {
        // 是否需要 set cookie
        if (needSetCookie) {
          // 提示 copy 成功
          pushSuccessMessage(this.i18nText.claimCodeSuccessTipText)

          // 设置 cookie
          let d = new Date()
          d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)) // 7天
          document.cookie = `discount_code=${code};expires=${d.toGMTString()};path=/`

          // 更新文案
          e.currentTarget.innerText = copiedText
        } else {
          // 提示 copy 成功
          pushSuccessMessage(this.i18nText.copyCodeSuccessTipText)
        }
      })
    }

    // 3600 plus 会员价
    if (this.actId) {
      // 数据埋码
      this.GAEvent({
        product_spu_name: this.spuTitle,
        module: 'EarlyBirdCoupons',
        position: this.DOM.querySelector('h3').innerText || '',
        button_name: 'CodeCopy',
        content: code,
        status: window.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
      })
    }
    // 非 3600 plus 会员价
    else {
      // 数据埋码
      this.GAEvent({
        position: this.spuTitle + ' # ' + this.skuTitle,
        button_name: needSetCookie ? cookieCode === code ? copiedText : copyText : 'coupon_code',
        type: this.displayText ? 'text' : 'pic',
        status: window.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
      })
    }
  }
  // 纯文本
  renderTextDOM({ cookieCode, discountCode, }) {
    // 已登录
    if (window.pageInfo?.customerInfo?.id) {
      const tip =
        discountCode
          ? `${this.i18nText.copyToApplyText.replace('{code}', `<span class="underline underline-offset-2 cursor-pointer" data-member-price-code data-code="${discountCode}" data-copy-text="${this.i18nText.copyText}" data-copied-text="${this.i18nText.copiedText}">${discountCode}</span>`).replace('{price}', this.discountAmount)}`
          : `${this.i18nText.clickToApplyText.replace('{price}', this.discountAmount)}`

      return `
        <div class="flex items-start justify-start flex-col gap-y-30 my-35 lg:j-gap-y-14 lg:j-my-30 xl:a-gap-y-14 xl:a-my-30">
          <p class="w-full font-normal text-#666 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24 ${!discountCode ? 'lg:j-gap-x-40 xl:a-gap-x-40 flex items-center justify-start' : ''}">
            <span
              class="font-normal text-#666 text-26 leading-42 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24"
            >${tip}</span>
            ${
              !discountCode
                ? `
                  <button
                    class="member-price-text-btn hidden lg:block appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16"
                    data-member-price-get
                  >
                    ${this.i18nText.getText}
                  </button>
                `
                : ''
            }
          </p>
          ${
            discountCode
             ? `
              <div class="w-full flex-between lg:flex-start lg:j-gap-x-50 xl:a-gap-x-50">
                <span class="text-#666 font-medium leading-none underline underline-offset-2 lg:j-text-16 xl:a-text-16 cursor-pointer" data-member-price-rules data-type="membership">
                  ${this.i18nText.rulesText}
                </span>
                <button
                  class="appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16"
                  data-member-price-copy
                  data-code="${discountCode}"
                  data-copy-text="${this.i18nText.copyText}"
                  data-copied-text="${this.i18nText.copiedText}"
                >
                  ${cookieCode === discountCode ? this.i18nText.copiedText : this.i18nText.copyText}
                </button>
              </div>
             `
             : `
              <div class="lg:hidden w-full flex items-center justify-end lg:flex-start lg:j-gap-x-50 xl:a-gap-x-50">
                <button
                  class="member-price-text-btn appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16"
                  data-member-price-get
                >
                  ${this.i18nText.getText}
                </button>
              </div>
             `
          }
        </div>
      `
    }

    // 未登录
    const tip = `${this.i18nText.loginToApplyText.replace('{price}', this.discountAmount)}`
    return `
      <div class="flex items-start justify-start flex-col gap-y-30 my-35 lg:j-gap-y-14 lg:j-my-30 xl:a-gap-y-14 xl:a-my-30 cursor-pointer" data-member-price-claim>
        <p class="w-full font-normal text-#666 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24 lg:j-gap-x-40 xl:a-gap-x-40 flex items-center justify-start">
          <span class="font-normal text-#666 text-26 leading-42 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24">${tip}</span>
          <button class="hidden lg:block appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16">${this.i18nText.claimText}</button>
        </p>
        <div class="lg:hidden w-full flex items-center justify-end lg:flex-start lg:j-gap-x-50 xl:a-gap-x-50">
          <button class="appearance-none bg-transparent text-#EE7A45 font-medium leading-none underline underline-offset-2 text-28 lg:j-text-16 xl:a-text-16">${this.i18nText.claimText}</button>
        </div>
      </div>
    `
  }
  renderImgDOM({ cookieCode, discountCode, imageType, imageUrl, }) {
    // 已登录
    if (window.pageInfo?.customerInfo?.id) {
      return `
        <div
          class="flex-between w-629 h-202 mt-40 mb-70 lg:a-w-346 lg:a-h-112 lg:j-mt-10 lg:j-mt-20 lg:j-mb-35 xl:a-w-346 xl:a-h-112 xl:a-mt-20 xl:a-mb-35"
          style="background: white url(${imageUrl}) center center /contain no-repeat;"
        >
          <div class="flex-center flex-col w-414 gap-y-12 lg:j-w-228 lg:j-gap-y-8 xl:a-w-228 xl:a-gap-y-8 ${imageType === 0 ? 'pt-105 lg:j-pt-60 xl:a-pt-60' : 'pt-15 lg:j-pt-10 xl:a-pt-10'}">
            ${
              imageType === 0
                ? ''
                : `
                  <div class="flex items-baseline">
                    <em class="text-#FE7704 not-italic font-bold leading-none text-80 lg:j-text-44 xl:a-text-44">${this.discountAmount}</em>
                    <span class="text-#FE7704 font-bold leading-none text-26 ml-5 lg:j-text-14 lg:j-mb-5 lg:j-ml-5 xl:a-text-14 xl:a-mb-5 xl:a-ml-5">${this.i18nText.offText}</span>
                  </div>
                `
            }
            ${
              discountCode
                ? `
                  <div class="flex-between gap-x-40 lg:j-gap-x-20 xl:a-gap-x-20">
                    <span
                      class="font-medium text-#FDA71A leading-none underline underline-offset-2 text-22 lg:j-text-12 xl:a-text-12 cursor-pointer"
                      data-member-price-code
                      data-code="${discountCode}"
                      data-copy-text="${this.i18nText.copyText}"
                      data-copied-text="${this.i18nText.copiedText}"
                    >${this.i18nText.codeText}:${discountCode}</span>
                    <span class="font-medium text-#FDA71A leading-none underline underline-offset-2 text-22 lg:j-text-12 xl:a-text-12 cursor-pointer" data-member-price-rules data-type="membership">${this.i18nText.rulesText}</span>
                  </div>
                `
                : ''
            }
          </div>
          ${
            discountCode
              ? `
                <div class="flex-center w-215 pt-15 lg:j-w-118 lg:j-pt-10 xl:a-w-118 xl:a-pt-10">
                  <button
                    class="rounded-full bg-primary font-semibold text-#FFFDF6 min-w-150 h-64 text-26 leading-none lg:j-min-w-82 lg:j-h-36 lg:j-text-14 lg:j-px-10 xl:a-min-w-82 xl:a-h-36 xl:a-text-14 xl:a-px-10"
                    data-member-price-copy
                    data-code="${discountCode}"
                    data-copy-text="${this.i18nText.copyText}"
                    data-copied-text="${this.i18nText.copiedText}"
                  >
                    ${cookieCode === discountCode ? this.i18nText.copiedText : this.i18nText.copyText}
                  </button>
                </div>
              `
              : `
                <div class="flex-center w-215 pt-15 lg:j-w-118 lg:j-pt-10 xl:a-w-118 xl:a-pt-10">
                  <button
                    class="flex-center rounded-full bg-primary font-semibold text-#FFFDF6 min-w-150 h-64 text-26 leading-none lg:j-min-w-82 lg:j-h-36 lg:j-text-14 lg:j-px-10 xl:a-min-w-82 xl:a-h-36 xl:a-text-14 xl:a-px-10"
                    data-member-price-get
                  >
                    ${this.i18nText.getText}
                  </button>
                </div>
              `
          }
        </div>
      `
    }

    // 未登录
    return `
      <div
        class="flex-between w-629 h-202 mt-40 mb-70 lg:a-w-346 lg:a-h-112 lg:j-mt-10 lg:j-mt-20 lg:j-mb-35 xl:a-w-346 xl:a-h-112 xl:a-mt-20 xl:a-mb-35 cursor-pointer"
        style="background: white url(${imageUrl}) center center /contain no-repeat;"
        data-member-price-claim
      >
        <div class="flex-center flex-col w-414 gap-y-12 lg:j-w-228 lg:j-gap-y-8 xl:a-w-228 xl:a-gap-y-8">
          ${
            imageType === 0
              ? ''
              : `
                <div class="flex items-baseline">
                  <em class="text-#FE7704 not-italic font-bold leading-none text-80 lg:j-text-44 xl:a-text-44">${this.discountAmount}</em>
                  <span class="text-#FE7704 font-bold leading-none text-26 ml-5 lg:j-text-14 lg:j-mb-5 lg:j-ml-5 xl:a-text-14 xl:a-mb-5 xl:a-ml-5">${this.i18nText.offText}</span>
                </div>
              `
          }
        </div>
        <div class="flex-center w-215 pt-15 lg:j-w-118 lg:j-pt-10 xl:a-w-118 xl:a-pt-10">
          <button class="rounded-full bg-primary font-semibold text-#FFFDF6 min-w-150 h-64 text-26 leading-none lg:j-min-w-82 lg:j-h-36 lg:j-text-14 lg:j-px-10 xl:a-min-w-82 xl:a-h-36 xl:a-text-14 xl:a-px-10">
            ${this.i18nText.claimText}
          </button>
        </div>
      </div>
    `
  }
  // 计算优惠价格
  calcDiscountPrice({value, valueType}) {
    // 固定减免金额
    if (valueType === 0) {
      const priceStr = formatMoney(new Decimal(value).mul(100).toNumber(), window.pageInfo?.currency?.money_format)
      return priceStr.replace(/\.00$|,00$/, '')
    }

    // 百分比减免
    return value + '%'
  }
  renderRulesDOM() {
    const { ruleInfo, imageType, imageUrl, } = this.curSkuInfo
    return `
      <div
        class="flex-between w-470 h-144 lg:a-w-346 lg:a-h-112 xl:a-w-346 xl:a-h-112"
        style="background: white url(${imageUrl}) ${this.actId ? 'left' : 'center'} center /contain no-repeat;"
      >
        <div class="flex-center flex-col w-310 gap-y-12 lg:j-w-228 lg:j-gap-y-8 xl:a-w-228 xl:a-gap-y-8">
          ${
            imageType === 0
              ? ''
              : `
                <div class="flex items-baseline">
                  <em class="text-#FE7704 not-italic font-bold leading-none text-60 lg:j-text-44 xl:a-text-44">${this.discountAmount}</em>
                  <span class="text-#FE7704 font-bold leading-none text-20 ml-5 lg:j-text-14 lg:j-mb-5 lg:j-ml-5 xl:a-text-14 xl:a-mb-5 xl:a-ml-5">${this.i18nText.offText}</span>
                </div>
              `
          }
        </div>
      </div>
      <h3 class="font-semibold text-#1A1A1A leading-none text-36 mt-30 mb-15 lg:j-text-20 lg:j-my-15 xl:a-text-20 xl:a-my-15">${this.i18nText.rulesText}</h3>
      <div class="font-normal text-#666 text-28 leading-42 lg:j-text-16 lg:j-leading-24 xl:a-text-16 xl:a-leading-24">${ruleInfo}</div>
    `
  }

  // 3600 plus 会员价
  render3600PlusImgDOM({ cookieCode, discountCode, variantInfo, ruleInfo, isShowCountDown }) {
    // 已登录
    if (window.pageInfo?.customerInfo?.id) {
      // 没有配置图片，不显示
      if (!variantInfo.membership_price_claimed_image) return ''

      return `
        <div class="mt-40 mb-70 lg:j-mt-20 lg:j-mb-35 xl:a-mt-20 xl:a-mb-35">
          <h3 class="text-#1A1A1A font-medium text-32 leading-48 mb-20 lg:a-text-16 lg:a-leading-20 lg:a-mb-8 xl:a-text-16 xl:a-leading-20 xl:a-mb-8">
            ${discountCode
              ? `${cookieCode === discountCode ? this.i18nText.loggedAndClaimedWithAutoApplyTitle : this.i18nText.loggedAndClaimedWithNoAutoApplyTitle}`
              : `${this.i18nText.loggedAndUnclaimedTitle}`
            }
          </h3>
          <div
            class="flex-end w-686 min-h-165 lg:a-w-400 lg:a-min-h-96 xl:a-w-400 xl:a-min-h-96 relative"
            style="background: white url(${discountCode ? variantInfo.membership_price_claimed_image : variantInfo.membership_price_unclaimed_image}) center center /contain no-repeat;"
          >
            ${ruleInfo
              ? `
                <button
                  class="absolute left-20 top-12 lg:a-left-10 lg:a-top-6 bg-transparent opacity-80 coupon-svg"
                  data-member-price-rules
                  data-code="${discountCode}"
                >
                  ${this.renderTipSVG()}
                </button>
              `
              : ''
            }
            ${discountCode
              ? `
                <div class="flex-center flex-col w-264 gap-y-20 lg:a-w-153 lg:a-gap-y-12">
                  <button
                    class="max-w-[90%] overflow-hidden text-ellipsis whitespace-nowrap !break-all text-center rounded-full bg-#FFF5E2 font-semibold text-#DD6000 h-68 text-30 leading-68 px-30 leading-none mt-8 lg:a-h-40 lg:a-text-18 lg:a-leading-40 lg:a-mt-4 lg:a-px-12"
                    data-member-price-copy
                    data-code="${discountCode}"
                    data-copy-text="${this.i18nText.loggedAndClaimedWithNoAutoApplyBtnText}"
                    data-copied-text="${this.i18nText.loggedAndClaimedWithAutoApplyBtnText}"
                  >
                    ${cookieCode === discountCode ? this.i18nText.loggedAndClaimedWithAutoApplyBtnText : this.i18nText.loggedAndClaimedWithNoAutoApplyBtnText}
                  </button>
                  <div class="flex-between gap-x-40 lg:j-gap-x-20 xl:a-gap-x-20">
                    <span
                      class="font-semibold text-#FFF1D1 leading-none text-22 lg:a-text-12 cursor-pointer"
                      data-member-price-code
                      data-code="${discountCode}"
                      data-copy-text="${this.i18nText.loggedAndClaimedWithNoAutoApplyBtnText}"
                      data-copied-text="${this.i18nText.loggedAndClaimedWithAutoApplyBtnText}"
                    >${this.i18nText.codeText}:${discountCode}</span>
                  </div>
                </div>
              `
              : `
                <div class="flex-center w-215 lg:a-w-153 xl:a-w-153">
                  <button
                    class="max-w-[90%] overflow-hidden text-ellipsis whitespace-nowrap !break-all text-center rounded-full bg-#FFF5E2 font-semibold text-#DD6000 h-68 text-30 leading-68 px-30 leading-none lg:a-h-40 lg:a-text-18 lg:a-leading-40 lg:a-px-12"
                    data-actId="true"
                    data-member-price-get
                  >
                    ${this.i18nText.loggedAndUnclaimedBtnText}
                  </button>
                </div>
              `
            }
          </div>
          ${isShowCountDown
            ? `
              <div class="flex items-center justify-start mt-24 lg:a-mt-8" data-count-down>
                <span class="font-semibold text-#FD5607 text-36 leading-52 mr-20 lg:a-text-16 lg:a-leading-24 lg:a-mr-10">${this.i18nText.endsInText}</span>
                <span class="inline-flex items-center justify-center font-semibold min-w-64 h-52 rounded-8 text-36 px-8 lg:a-min-w-30 lg:a-h-24 lg:a-pt-2 lg:a-rounded-4 lg:a-text-16 lg:a-leading-24 lg:a-px-4 bg-#FD5707 text-white"></span>
                <span class="mx-5 text-36 leading-52 lg:a-text-16 lg:a-leading-24 lg:a-mx-2 text-#FD5607 font-semibold">:</span>
                <span class="inline-flex items-center justify-center font-semibold min-w-64 h-52 rounded-8 text-36 px-8 lg:a-min-w-30 lg:a-h-24 lg:a-pt-2 lg:a-rounded-4 lg:a-text-16 lg:a-leading-24 lg:a-px-4 bg-#FD5707 text-white"></span>
                <span class="mx-5 text-36 leading-52 lg:a-text-16 lg:a-leading-24 lg:a-mx-2 text-#FD5607 font-semibold">:</span>
                <span class="inline-flex items-center justify-center font-semibold min-w-64 h-52 rounded-8 text-36 px-8 lg:a-min-w-30 lg:a-h-24 lg:a-pt-2 lg:a-rounded-4 lg:a-text-16 lg:a-leading-24 lg:a-px-4 bg-#FD5707 text-white"></span>
                <span class="mx-5 text-36 leading-52 lg:a-text-16 lg:a-leading-24 lg:a-mx-2 text-#FD5607 font-semibold">:</span>
                <span class="inline-flex items-center justify-center font-semibold min-w-64 h-52 rounded-8 text-36 px-8 lg:a-min-w-30 lg:a-h-24 lg:a-pt-2 lg:a-rounded-4 lg:a-text-16 lg:a-leading-24 lg:a-px-4 bg-#FD5707 text-white"></span>
              </div>
            `
            : ''
          }
        </div>
      `
    }


    // 未登录
    // 没有配置图片，不显示
    if (!variantInfo.membership_price_unclaimed_image) return ''
    
    return `
      <div class="mt-40 mb-70 lg:j-mt-20 lg:j-mb-35 xl:a-mt-20 xl:a-mb-35">
        <h3 class="text-#1A1A1A font-medium text-32 leading-48 mb-20 lg:a-text-16 lg:a-leading-20 lg:a-mb-8 xl:a-text-16 xl:a-leading-20 xl:a-mb-8">${this.i18nText.noLoginTitle}</h3>
        <div
          class="flex-end w-686 min-h-165  lg:a-w-400 lg:a-min-h-96 xl:a-w-400 xl:a-min-h-96 cursor-pointer relative"
          style="background: white url(${variantInfo.membership_price_unclaimed_image}) center center /contain no-repeat;"
          data-member-price-claim
        >
          <div class="flex-center w-264 lg:a-w-153">
            <button class="max-w-[90%] overflow-hidden text-ellipsis whitespace-nowrap !break-all text-center rounded-full bg-#FFF5E2 font-semibold text-#DD6000 h-68 text-30 leading-68 px-30 leading-none lg:a-h-40 lg:a-text-18 lg:a-leading-40 lg:a-px-12">
              ${this.i18nText.noLoginBtnText}
            </button>
          </div>
        </div>
        ${isShowCountDown
          ? `
            <div class="flex items-center justify-start mt-24 lg:a-mt-8" data-count-down>
              <span class="font-semibold text-#FD5607 text-36 leading-52 mr-20 lg:a-text-16 lg:a-leading-24 lg:a-mr-10">${this.i18nText.endsInText}</span>
              <span class="inline-flex items-center justify-center font-semibold min-w-64 h-52 rounded-8 text-36 px-8 lg:a-min-w-30 lg:a-h-24 lg:a-pt-2 lg:a-rounded-4 lg:a-text-16 lg:a-leading-24 lg:a-px-4 bg-#FD5707 text-white"></span>
              <span class="mx-5 text-36 leading-52 lg:a-text-16 lg:a-leading-24 lg:a-mx-2 text-#FD5607 font-semibold">:</span>
              <span class="inline-flex items-center justify-center font-semibold min-w-64 h-52 rounded-8 text-36 px-8 lg:a-min-w-30 lg:a-h-24 lg:a-pt-2 lg:a-rounded-4 lg:a-text-16 lg:a-leading-24 lg:a-px-4 bg-#FD5707 text-white"></span>
              <span class="mx-5 text-36 leading-52 lg:a-text-16 lg:a-leading-24 lg:a-mx-2 text-#FD5607 font-semibold">:</span>
              <span class="inline-flex items-center justify-center font-semibold min-w-64 h-52 rounded-8 text-36 px-8 lg:a-min-w-30 lg:a-h-24 lg:a-pt-2 lg:a-rounded-4 lg:a-text-16 lg:a-leading-24 lg:a-px-4 bg-#FD5707 text-white"></span>
              <span class="mx-5 text-36 leading-52 lg:a-text-16 lg:a-leading-24 lg:a-mx-2 text-#FD5607 font-semibold">:</span>
              <span class="inline-flex items-center justify-center font-semibold min-w-64 h-52 rounded-8 text-36 px-8 lg:a-min-w-30 lg:a-h-24 lg:a-pt-2 lg:a-rounded-4 lg:a-text-16 lg:a-leading-24 lg:a-px-4 bg-#FD5707 text-white"></span>
            </div>
          `
          : ''
        }
      </div>
    `
  }
  renderTipSVG() {
    return `
      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.900000036">
          <g transform="translate(-1292.000000, -334.000000)" fill="#FFFEF4" fill-rule="nonzero">
            <g transform="translate(1292.000000, 334.000000)">
              <path d="M8,16 C3.582,16 0,12.418 0,8 C0,3.582 3.582,0 8,0 C12.418,0 16,3.582 16,8 C16,12.418 12.418,16 8,16 Z M8,14.6666667 C11.682,14.6666667 14.6666667,11.682 14.6666667,8 C14.6666667,4.318 11.682,1.33333333 8,1.33333333 C4.318,1.33333333 1.33333333,4.318 1.33333333,8 C1.33333333,11.682 4.318,14.6666667 8,14.6666667 Z M8,6.66666666 C8.4418278,6.66666666 8.8,6.96514349 8.8,7.33333333 C8.8,8.14832097 8.8,8.75733823 8.8,9.16038513 C8.8,9.79437527 8.8,10.7409136 8.8,12 C8.8,12.3681898 8.4418278,12.6666667 8,12.6666667 C7.5581722,12.6666667 7.2,12.3681898 7.2,12 L7.2,7.33333333 C7.2,6.96514349 7.5581722,6.66666666 8,6.66666666 Z M7.93333333,5.2 C7.41786756,5.2 6.99999999,4.78213243 6.99999999,4.26666666 C6.99999999,3.7512009 7.41786756,3.33333333 7.93333333,3.33333333 C8.4487991,3.33333333 8.86666666,3.7512009 8.86666666,4.26666666 C8.86666666,4.78213243 8.4487991,5.2 7.93333333,5.2 L7.93333333,5.2 Z" id="形状"></path>
            </g>
          </g>
        </g>
      </svg>
    `
  }
  // 倒计时初始化
  async initCountdownData({ serverTime, startTime, endTime, }) {
    if (serverTime >= startTime) {
      this.tick(endTime, serverTime)
    } else {
      // 移除DOM
      this.DOM.parentElement.removeChild(this.DOM)
    }
  }
  // 倒计时 span
  renderCountdownSpan(days, hours, minutes, seconds) {
    const numberStyle = 'inline-flex items-center justify-center font-semibold min-w-64 h-52 rounded-8 text-36 leading-52 px-8 lg:a-min-w-30 lg:a-h-24 lg:a-pt-2 lg:a-rounded-4 lg:a-text-16 lg:a-leading-24 lg:a-px-4 bg-#FD5707 text-white'
    const colonStyle = 'mx-5 text-36 leading-52 lg:a-text-16 lg:a-leading-24 lg:a-mx-2 text-#FD5607 font-semibold'

    return `
      <span class="font-semibold text-#FD5607 text-36 leading-52 mr-20 lg:a-text-16 lg:a-leading-24 lg:a-mr-10">${this.i18nText.endsInText}</span>
      <span class="${numberStyle}">${days || ''}</span>
      <span class="${colonStyle}">:</span>
      <span class="${numberStyle}">${hours || ''}</span>
      <span class="${colonStyle}">:</span>
      <span class="${numberStyle}">${minutes || ''}</span>
      <span class="${colonStyle}">:</span>
      <span class="${numberStyle}">${seconds || ''}</span>
    `
  }
  // 倒计时
  tick(target, current) {
    const leftTime = (target - current) / 1000
    let days, hours, minutes, seconds

    // 倒计时结束
    if (leftTime <= 0) {
      this.timer && clearTimeout(this.timer)

      // 清空 DOM
      this.DOM.innerHTML = ''
      this.DOM.parentElement.style.display = 'none'
      this.DOM.parentElement.setAttribute('data-show', false)

      // 3600 plus，【已登录】，更新【价格】、【划线价】
      if (this.actId && window.pageInfo?.customerInfo?.id) {
        const variantInfo = this.getSelectedVariant()

        // 更新 window.productMemberPriceInfo
        window.productMemberPriceInfo = window.productMemberPriceInfo.filter(item => item.id.toString() !== variantInfo.id.toString())
        // 更新 spuInfo
        this.spuInfo = this.spuInfo.filter(item => item.skuId.toString() !== variantInfo.id.toString())

        // 更新 【选中变体的价格】、添加【选中变体的划线价】
        if (variantInfo.membership_price < variantInfo.price && document.querySelector('variant-fields')) {
          const parentEl = document.querySelector(`variant-fields input[data-id="${variantInfo.id}"]`)?.parentElement
          if (parentEl?.querySelector('.option-price span.price')) {
            parentEl.querySelector('.option-price span.price').innerText = formatMoney(variantInfo.price)
          }

          // 删除 划线价
          if (parentEl?.querySelector('.option-price span.origin-price')) {
            if (variantInfo.compare_at_price === variantInfo.price) {
              parentEl.querySelector('.option-price').removeChild(parentEl.querySelector('.option-price span.origin-price'))
            }
          }
        }
        
        // 更新 吸底购物车【价格】、【划线价】、【折扣】
        if (document.querySelector('jky-sticky-cart')) {
          const stickyCart = document.querySelector('jky-sticky-cart')?.querySelector('.sticky_cart_price_wrap')
          if (!stickyCart) return

          stickyCart.querySelector('.sticky_cart_price').innerText = formatMoney(variantInfo.price)

          // 划线价
          if (stickyCart.querySelector('.product--originPrice')) {
            // 删除【划线价】
            if (variantInfo.compare_at_price === variantInfo.price) {
              stickyCart.removeChild(stickyCart.querySelector('.product--originPrice'))
            }
            // 更新【划线价】
            else {
              stickyCart.querySelector('.product--originPrice').innerText = formatMoney(variantInfo.compare_at_price)
            }
          }

          // 折扣金额
          if (stickyCart.querySelector('.product-price--discount_amount')) {
            // 删除【折扣】
            if (variantInfo.compare_at_price === variantInfo.price) {
              stickyCart.removeChild(stickyCart.querySelector('.product-price--discount_amount'))
            }
            // 更新【折扣】
            else {
              const dis_amount = Math.floor((variantInfo.compare_at_price - variantInfo.price) / 100) * 100
              let money_format = window?.pageInfo?.currency?.money_format?.replace('{{amount}}', '{{amount_no_decimals}}')
              money_format = money_format?.replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
              const discountPrice = formatMoney(dis_amount, money_format)
              const discountEl = stickyCart.querySelector('.product-price--discount_amount')
              discountEl.innerText = discountEl.dataset.format.replace('()', discountPrice)
            }
          }
        }
      }
    } else {
      days = String(parseInt(leftTime / 60 / 60 / 24)).padStart(2, '0')
      hours = String(parseInt(leftTime / 60 / 60 % 24)).padStart(2, '0')
      minutes = String(parseInt(leftTime / 60 % 60)).padStart(2, '0')
      seconds = String(parseInt(leftTime % 60)).padStart(2, '0')

      if (this.countdownDOM) {
        this.countdownDOM.innerHTML = this.renderCountdownSpan(days, hours, minutes, seconds)
      }

      this.timer = setTimeout(() => this.tick(target, current + 1000), 1000)
    }
  }

  // 数据埋码
  GAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"membership_price_user_clicks",
      "event_parameters":{
        "current_page": window.location.href, // current page url
        "module": "Product Detail",
        ...params
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // 会员价
  new ProductMembershipPrice()
})
